defineDs('DanskeSpil/Domain/Tips/Scripts/SystemGuide', [
  'Common/Framework/EventHandling/Scripts/Event',
], function (Event) {
  Event.subscribe('overlay-opened', function (params) {

    /**
     * Tips systems tab navigation
     */
    const $container = params?.$container;
    const $tabs = $container?.querySelectorAll('.js-tips-tap .tab');
    const $tabPages = $container?.querySelectorAll('.js-tips-tap .tab-page');

    $tabs.forEach(($element) => {
      $element.addEventListener('click', (event) => {

        $tabs.forEach(($element) => {
          $element.classList.remove('active');
        });

        const $element = event.target;
        const index = $element.getAttribute('data-tabindex');
        $element.classList.add('active');

        $tabPages.forEach(($element) => {
          $element.classList.add('hidden');
        });

        $tabPages[index]?.classList.remove('hidden');
      });
    });

    /**
     * Tips systems toggle type buttuns between r- and u-system select
     */
    const typeButtonClicked = (event) => {
      const $element = event.target;

      if (!$element.classList.contains('selected')) {
        $container.querySelector('.js-type-button.selected').classList.remove('selected');
        $element.classList.add('selected');

        $container.querySelector('#r-select')?.classList.toggle('hidden', $element.id !== 'r-button');
        $container.querySelector('#u-select')?.classList.toggle('hidden', $element.id !== 'u-button');
      }
    };

    $container.querySelector('#r-button')?.addEventListener('click', typeButtonClicked);
    $container.querySelector('#u-button')?.addEventListener('click', typeButtonClicked);

    /**
     * Select on change link to chosen system
     */
    const selectSystemChanged = (event) => {
      const $element = event.target;
      const systemName = $element.value;
      if (systemName) {
        const $selected = $element.querySelector('[value=\'' + systemName + '\']');
        const link = $selected.getAttribute('data-url');
        if (link) {
          document.location.href = link;
        }
      }
    };

    $container.querySelector('#r-select')?.addEventListener('change', selectSystemChanged);
    $container.querySelector('#u-select')?.addEventListener('change', selectSystemChanged);

  });
});
